'use client';

import { createContext } from 'react';

import type { UpsellBannerRootContextInterface } from '../types/upsell-banner-root.types';

export const UpsellBannerRootContext = createContext<UpsellBannerRootContextInterface>({});

UpsellBannerRootContext.displayName = 'UpsellBanner.Root.Context';
